import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { StoreService } from 'app/services';
import { LocationType } from 'app/models';

@Component({
    selector: 'partner-mart-locations-handoff',
    templateUrl: './partner-mart-locations-handoff.component.html',
    styleUrls: ['./partner-mart-locations-handoff.component.scss',
        '../../../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})
export class PartnerMartLocationsHandoffComponent implements OnInit {
    @Input()
    public storeId: number = 0;

    @Input()
    public store: any = {};

    public locationType = LocationType.LocationTypeList;

    public loading: boolean = false;
    public storeData: any = {};

    public showDeliveryDetailSideBar: boolean = false;

    constructor(private messageService: MessageService, private storeService: StoreService) {
    }

    ngOnInit(): void {
        if (this.storeId > 0) {
            this.getStore();
        }
    }

    getStore() {
        this.loading = true;
        const dto = {
            StoreId: this.storeId
        };

        this.storeService.getStore(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.storeData = data;
                this.storeData.LoacationTypeName = this.locationType.find(f => f.value === data.LocationTypeId).name;
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    public openDeliveryDetailSideBar() {
        this.showDeliveryDetailSideBar = !this.showDeliveryDetailSideBar;
    }
    changedShowDeliveryDetailSideBarEmit(value: any) {
        this.showDeliveryDetailSideBar = value;
    }
}
